import { usePostHog } from 'posthog-js/react';
import { useState, useEffect } from 'react';

export function useOrganizationOnboardingFlag() {
  const posthog = usePostHog();
  const [isEnabled, setIsEnabled] = useState<boolean>(true); // Default to enabled
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    if (!posthog) {
      setLoading(false);
      return;
    }

    const checkFlag = async () => {
      try {
        const flagValue = await posthog.isFeatureEnabled('organization-onboarding');
        setIsEnabled(Boolean(flagValue));
      } catch (error) {
        console.error('Error checking organization-onboarding flag:', error);
        setIsEnabled(true); // Default to enabled on error
      } finally {
        setLoading(false);
      }
    };

    checkFlag();
  }, [posthog]);

  return { isEnabled, loading };
}

// export function useCheckoutFlag() {
//   const posthog = usePostHog();
//   const [isEnabled, setIsEnabled] = useState<boolean>(true); // Default to enabled
//   const [loading, setLoading] = useState<boolean>(true);

//   useEffect(() => {
//     if (!posthog) {
//       setLoading(false);
//       return;
//     }

//     const checkFlag = async () => {
//       try {
//         const flagValue = await posthog.isFeatureEnabled('checkout');
//         setIsEnabled(Boolean(flagValue));
//       } catch (error) {
//         console.error('Error checking checkout flag:', error);
//         setIsEnabled(true); // Default to enabled on error
//       } finally {
//         setLoading(false);
//       }
//     };

//     checkFlag();
//   }, [posthog]);

//   return { isEnabled, loading };
// }

// export function useBursarySystemFlag() {
//   const posthog = usePostHog();
//   const [isEnabled, setIsEnabled] = useState<boolean>(true); // Default to enabled
//   const [loading, setLoading] = useState<boolean>(true);

//   useEffect(() => {
//     if (!posthog) {
//       setLoading(false);
//       return;
//     }

//     const checkFlag = async () => {
//       try {
//         const flagValue = await posthog.isFeatureEnabled('bursary-system');
//         setIsEnabled(Boolean(flagValue));
//       } catch (error) {
//         console.error('Error checking bursary-system flag:', error);
//         setIsEnabled(true); // Default to enabled on error
//       } finally {
//         setLoading(false);
//       }
//     };

//     checkFlag();
//   }, [posthog]);

//   return { isEnabled, loading };
// } 